// Mock data for IronQuill Consulting website

export const services = [
  {
    id: 1,
    title: "Proposal Development",
    description: "End-to-end proposal writing and development services that transform your technical capabilities into compelling, compliant, and competitive submissions.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Capture Support",
    description: "Strategic capture planning from opportunity identification through submission, ensuring your team is positioned to win before the RFP drops.",
    icon: "Target"
  },
  {
    id: 3,
    title: "Proposal Management",
    description: "Expert coordination of proposal teams, schedules, and deliverables to ensure on-time, compliant submissions that maintain quality under pressure.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Proposal Design",
    description: "Professional visual design and formatting that makes your proposals stand out while maintaining readability and regulatory compliance.",
    icon: "Palette"
  }
];

export const processSteps = [
  {
    id: 1,
    phase: "Capture",
    title: "Strategic Planning",
    description: "We analyze the opportunity, assess competitive positioning, and develop win themes before the RFP is released.",
    details: ["Market intelligence gathering", "Competitor analysis", "Teaming strategy", "Win theme development"]
  },
  {
    id: 2,
    phase: "Development",
    title: "Content Creation",
    description: "Our experts craft compelling narratives that showcase your technical approach while addressing all compliance requirements.",
    details: ["Compliance matrix development", "Technical solution design", "Past performance integration", "Value proposition refinement"]
  },
  {
    id: 3,
    phase: "Review",
    title: "Quality Assurance",
    description: "Rigorous color team reviews ensure your proposal is competitive, compliant, and compelling before submission.",
    details: ["Pink team reviews", "Red team evaluations", "Compliance verification", "Executive summaries"]
  },
  {
    id: 4,
    phase: "Submission",
    title: "Final Delivery",
    description: "We manage the final production, formatting, and submission process to ensure flawless delivery on deadline.",
    details: ["Desktop publishing", "Quality control", "Electronic submission", "Hard copy production"]
  }
];

export const caseStudies = [
  {
    id: 1,
    client: "Federal IT Services Contractor",
    challenge: "Needed to respond to a complex $50M IDIQ RFP with only 30 days to proposal submission.",
    solution: "IronQuill provided full proposal management, including compliance matrix development, technical writing, and color team reviews.",
    result: "Client achieved a highly competitive evaluation score and secured award in a multi-bid environment, positioning the client for long-term task order opportunities.",
    industry: "Government IT",
    value: "$10M"
  },
  {
    id: 2,
    client: "Defense Consulting Startup",
    challenge: "First-time government contractor pursuing a $3.4 M contract without prior proposal experience or past performance.",
    solution: "We led capture strategy, developed teaming relationships, and created a compelling technical narrative emphasizing innovation.",
    result: "Won the competitive procurement launching their federal practice.",
    industry: "NY State Contract",
    value: "$3.4 M"
  },
  {
    id: 3,
    client: "Healthcare Analytics Firm",
    challenge: "Losing pattern on federal proposals despite strong technical capabilities and competitive pricing.",
    solution: "IronQuill redesigned their proposal approach with stronger win themes, executive summaries, and visual presentation.",
    result: "Improved proposal effectiveness over a series of submissions, significantly strengthening win consistency across federal bids",
    industry: "Healthcare IT",
    value: "Multiple Awards"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    title: "VP of Business Development",
    company: "Apex Federal Solutions",
    quote: "IronQuill transformed how we approach proposals. Their strategic guidance during capture and disciplined proposal management helped us win our largest contract to date. They're not just writers—they're true business partners.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Michael Chen",
    title: "CEO",
    company: "TechForward Consulting",
    quote: "As a first-time government contractor, we were overwhelmed by the RFP process. IronQuill's team guided us through capture, compliance, and proposal development. We won on our first attempt—something our competitors said was impossible.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Jennifer Rodriguez",
    title: "Director of Proposals",
    company: "Integrated Systems Group",
    quote: "IronQuill's proposal design capabilities elevated our submissions from standard to exceptional. Their attention to compliance detail and ability to distill complex technical solutions into clear narratives gave us a competitive edge.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop"
  }
];

export const differentiators = [
  {
    id: 1,
    title: "End-to-End Lifecycle Support",
    description: "Unlike point-solution providers, we support the entire proposal lifecycle from capture strategy through submission, ensuring consistency and strategic alignment throughout.",
    impact: "Reduces coordination overhead and ensures win themes carry through from capture to final submission"
  },
  {
    id: 2,
    title: "Evaluator-Informed Review Perspective",
    description: "Our team includes former government contracting officers and proposal evaluators who understand exactly how your submissions will be scored.",
    impact: "Proposals designed from the evaluator's perspective, anticipating questions and addressing concerns proactively"
  },
  {
    id: 3,
    title: "Industry-Specific Expertise",
    description: "We specialize in complex technical proposals for government contractors, consulting firms, and IT services companies—not generic RFP responses.",
    impact: "Deep understanding of compliance requirements, evaluation criteria, and competitive dynamics in your market"
  },
  {
    id: 4,
    title: "Scalable Engagement Models",
    description: "From full proposal outsourcing to targeted support for specific gaps, we adapt to your team's capabilities and capacity constraints.",
    impact: "Cost-effective solutions that complement your existing resources without requiring full-time headcount"
  }
];

export const stats = [
  {
    label: "Win Rate Improvement",
    value: "30%",
    description: "Average increase in client win rates"
  },
  {
    label: "Proposals Delivered",
    value: "75+",
    description: "Successful submissions managed"
  },
  {
    label: "Contract Value",
    value: "$25M+",
    description: "Total value of won contracts"
  },
  {
    label: "On-Time Delivery",
    value: "100%",
    description: "Never missed a submission deadline"
  }
];
